import { SPEND_MODE_EVENT_TYPE } from "./SpendEnum";
import {SpendModeEventI, SpendModeEventMapM} from "./SpendInterface";

let eventMap:SpendModeEventMapM = {
//     "1":{//表姑 开始！第一天
//         id:"1",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         simpleDesc:"小明啊！一晃就这么大了还记的姑不？",
//         startTaskFlag : true,
//         startDay:0,
//         dec:"我就知道，你还记得表姑,表姑小时候还抱过你呢！没想到一晃你这么大了！",
//         chooseArr:[
//             {name:"记得!",nextEventId:2},
//             {name:"不记得!",nextEventId:5},
//         ],
//     },
//     "2":{
//         id:"2",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         simpleDesc:"",
//         dec:"你打小就记忆力好，我就说你就有出息！这不还给我们搞了个圆梦大会！",
//         chooseArr:[
//             {name:"谦虚一下!",nextEventId:3,meAsk:"哈哈哈！那没有呢?表姑你来这里是要干嘛？"},
//             {name:"嘚瑟一下!",nextEventId:9,meAsk:"那可不吗？从小我就过目不忘！"},
//         ],
//     },
//     "3":{
//         id:"3",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         simpleDesc:"",
//         dec:"差点忘了，来这里是有正经事情要跟你聊，表姑想要去浙江温州搞批发，需要点钱",
//         chooseArr:[
//             {name:"赞同!",nextEventId:4,meAsk:"那感情好！需要我帮助什么吗？"},
//             {name:"不赞同!",nextEventId:11,meAsk:"姑！浙江温州搞批发的人太多了你要不还是想想别的吧！",skipEvent: true},//对应（simpleDesc:"解决",）
//         ],
//     },
//     "4":{
//         id:"4",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         simpleDesc:"",
//         dec:"缺点钱，也不多对你这个大老板来说，撒撒水 50w 我赚到钱平分给你。",
//         chooseArr:[
//             {
//                 name:"给!",nextEventId:5,meAsk:"表姑的事情还是要支持的，这里是50w表姑拿去吧",
//                 skipEvent: true ,
//                 chooseParam : { key : "coin" , value : -500000 },
//                 logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "开启项目的第一天，表姑打算去浙江温州搞批发，花了50w",
//                         //影响盘子金额
//                         coinChange : -500000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                     {
//                         desc : "由于表姑对市场不了解，亏损30w",
//                         //影响盘子金额
//                         coinChange : -300000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 300000,
//                         //追投文案
//                         chasingThrowDesc : "表姑在浙江温州搞批发，但是由于对市场预估情况不足，买了江南皮革厂好多皮鞋！都快亏完了，你再追投一些呗30w就够了",
//                         //追投 下一个事件id
//                         eventId:13,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "当当当，表姑直播买起了鞋！赚了200w分了你100w",
//                         //影响盘子金额
//                         coinChange : 1000000,
//                         //影响用户金额
//                         userCoinChange : 1000000,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                 ],
//             },
//             {name:"不给!",nextEventId:11,meAsk:"表姑，这50w 也不是小数目，你要不等我想好再说"},
//         ],
//     },

//     // 表姑 第二天
//     "5":{
//         id:"5",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"哎!也对那时候你还小,不记得很正常！表姑跟你说个正经事.",
//         simpleDesc:"给你说的正经事",
//         chooseArr:[
//             {name:"听听!",nextEventId:6,meAsk:"表姑你说呗"},
//             {name:"闲聊!",nextEventId:6,meAsk:"表姑，你说事就行！你这样说话我害怕"},
//         ],
//     },
//     "6":{
//         id:"6",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"表姑想要去浙江温州搞批发，需要你帮助一下！.",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"赞同!",nextEventId:8,meAsk:"那感情好！表姑是想要我帮忙吗？"},
//             {name:"不赞同!",nextEventId:11},
//         ],
//     },
//     "8":{
//         id:"8",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"支持不能光靠嘴啊，我看你实际行动！我就直接说了哈！缺点钱，对你这个大老板来说也不多撒撒水50w",
//         simpleDesc:"表姑需要你支持",
//         chooseArr:[
//             {name:"给!",nextEventId:13,meAsk:"表姑的事情还是要支持的，这里是50w表姑拿去吧",skipEvent: true ,chooseParam : { key : "coin" , value : -500000}},//simpleDesc
//             {name:"不给",nextEventId:11,},
//         ],

//     },
//     "9":{
//         id:"9",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"那是那是！表姑就不跟你废话了！我今天来呢，是想找你圆一下我的梦",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"说出你的梦想!",nextEventId:12,meAsk:"说出你的梦想"},
//             {name:"什么梦想",nextEventId:12,meAsk:"你有什么梦想"}
//         ],
//     },
//     "10": {
//         id: "10",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "温州批发",
//         belongNpc: "表姑",
//         dec: "也不多对你这个大老板来说，撒撒水50w我赚到钱平分给你！",
//         simpleDesc:"",
//         chooseArr: [
//             {
//                 name: "给!",
//                 nextEventId: 13,
//                 meAsk: "表姑的事情还是要支持的，这里是50w表姑拿去吧",
//                 skipEvent: true,
//                 chooseParam: {key: "coin", value: -500000},
//             },
//             {name: "不给", nextEventId: 11},
//         ],
//     },
//     "11":{
//         id:"11",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"表姑听到你的拒绝后，一脸不开心的走了",
//         simpleDesc:"我不开心了",
//         chooseArr:[{name:"我知道了",skipEvent: true }],
//     },
//     //表姑第一天结束
//     "13":{// 第二天投资后 ！表姑//气泡！亏钱了
//         id:"13",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         simpleDesc:"亏钱了",
//         dec:"表姑在浙江温州，搞批发但是由于对市场预估情况不足，买了江南皮革厂好多皮鞋！都快亏完了，你再追投一些呗 30w 就够了 ",
//         chooseArr:[
//             {name:"追投!",meAsk:"表姑，你先拿着钱去吧！我相信你！可以的-30w",skipEvent: true ,chooseParam : { key : "coin" , value : -300000}},
//             {name:"不追投!",meAsk:"表姑，要不还是算了吧",nextEventId:14},
//         ],
//     },
//     "14":{
//         id:"14",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"表姑听到你的拒绝后，一脸不开心的走了",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"我知道了",skipEvent: true },
//         ],
//     },
// //第二天未投资 重新走第一天的  结束
//     "15":{//老六 开始！第一天（气泡老六：我是老六啊！兄弟看这里）
//         id:"15",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"我是老六啊！兄弟看这里",
//         startTaskFlag : true,
//         startDay:0,
//         dec:"兄弟！我老早就听说你回来了，我有个东西，是你当初写给我的我一直珍藏了很久！想着你回来了就拿给你看一看！",
//         chooseArr:[
//             {name:"拿来看一下!",nextEventId:16},
//             {name:"视而不见!",nextEventId:21,meAsk:"啥东西啊，我不看！"},
//         ],
//     },

//     "16":{
//         id:"16",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"这个承诺你就说还可以兑现不！",//+一个图
//         simpleDesc:"",
//         chooseArr:[
//             {name:"不承认!",nextEventId:17,meAsk:"那都是小时候的事情哪里可以当真啊"},
//             {name:"承认",nextEventId:22},
//         ],
//     },
//     "17":{
//         id:"17",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"你都这么大个老板了，说出的事情！哪里不能兑现啊！上面还有你盖的指纹呢！！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"不承认!",nextEventId:18,meAsk:"你看这借条上都没有名字，这谁认啊！"},
//             {name:"承认",nextEventId:22,meAsk:"当然算！当然算！六哥有事你说话？"},
//         ],
//     },
//     "18":{
//         id:"18",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"你这是要跟六哥翻脸了？这么重要的事情,你不认账了？行了不管你认不认我是想搞个项目！你出钱 我出力，咱们合伙搞个项目",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"什么项目!",nextEventId:19},
//             {name:"怼一下",nextEventId:23,meAsk:"有这好事你会想着我？"},
//         ],
//     },
//     "19":{
//         id:"19",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"新能源汽车你知道不？新能源全世界这么火但是摩托车市场居然没人做!我在想要不搞个新能源摩托车！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"你还真是个天才",nextEventId:20},
//             {name:"问问他怎么来的",nextEventId:24,meAsk:"你从哪里来的"},
//         ],
//     },
//     "20":{
//         id:"20",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"",
//         dec:"那可不，打小我就比你聪明，要不是我运气不好！这样你先给我个60w 就成，就这两年，要你赚，哥也好娶媳妇",
//         chooseArr:[
//             {name:"给他",meAsk:"出于道义，你还是拿了60w给了这个老六",nextEventId:28,skipEvent: true ,chooseParam : { key : "coin" , value : -600000 }//28
//                 ,logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "开启项目的第一天，新能源模特车如茶似火举行中，花了60w",
//                         //影响盘子金额
//                         coinChange : -600000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                     {
//                         desc : "由于新能源市场饱和，亏损50w",
//                         //影响盘子金额
//                         coinChange : -500000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 800000,
//                         //追投文案
//                         chasingThrowDesc : "新能源汽车已经饱和了！卖不出去，没关系我另外一个朋友凤雏！出了一个想法，将新年能源摩托车，改成共享的！但是前期推广运营费用需要80w你是否选择追投",
//                         //追投 下一个事件id
//                         eventId:38,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "由于你精准的商业眼光，本次投资已经已经你分了500w",
//                         //影响盘子金额
//                         coinChange : 10000000,
//                         //影响用户金额
//                         userCoinChange : 5000000,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                 ],},

//             {name:"不给",nextEventId:27},
//         ],
//     },
//     "21":{
//         id:"21",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"六哥强行把东西塞丢进了你怀里！",//+图片
//         simpleDesc:"",
//         chooseArr:[
//             {name:"不承认!",nextEventId:18,meAsk:"你看这借条上都没有名字，这谁认啊！"},
//             {name:"承认",nextEventId:22,meAsk:"当然算！当然算！六哥你是有啥事吗？"},
//         ],
//     },
//     "22":{
//         id:"22",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"我呢最近看上了一个姑娘！但是手上还缺点钱！不过六哥不是找你借钱哈！六哥是想搞个项目！你拿我点钱我们一起合伙，等我赚钱了，这样媳妇的也有了，你也有的赚",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"了解一下!",nextEventId:19,meAsk:"什么项目啊？"},
//             {name:"项目？",nextEventId:19,meAsk:"什么项目啊？"}
//         ],
//     },
//     "23":{
//         id:"23",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         dec:"那可不，六哥可是啥事都想着你！你先听我讲一下这个项目！新能源汽车你知道不？全世界这么火但是摩托车市场没人管啊！我在想要不搞个新能源摩托车！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"你还真是个天才!",nextEventId:20,},
//             {name:"问问他怎么来的",nextEventId:24,meAsk:"老六啊！我在想你是怎么来我家的？"},
//         ],
//     },
//     "24":{
//         id:"24",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"",
//         dec:"那可不，六哥可是啥事都想着你！你先听我讲一下这个项目！新能源汽车你知道不？全世界这么火但是摩托车市场没人管啊！我在想要不搞个新能源摩托车！",
//         chooseArr:[
//             {name:"你还真是个天才!",nextEventId:28},
//             {name:"问问他怎么来的",nextEventId:24,meAsk:"老六啊！我在想你是怎么来我家的？"},
//         ],
//     },
//     "25":{
//         id:"25",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"",
//         dec:"我心爱的小电驴啊！怎么了 你干嘛问我这个事情啊我们可以说正式吗？",
//         chooseArr:[
//             {name:"问他，电驴怎么动的!",nextEventId:26,meAsk:"老六啊！你要不回去想想你心爱的电驴如何行动的"},
//             {name:"劝老六回去",nextEventId:27,meAsk:"老六！你先回去我考虑一下吧"},
//         ],
//     },
//     "26":{
//         id:"26",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"",
//         dec:"当然是用电了，不然还..........  你知道不？你扼杀了一个商业天才！",
//         chooseArr:[
//             {name:"我知道了",skipEvent: true},
//         ],
//     },
//     "27":{
//         id:"27",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"",
//         dec:"回到家里后，老六痛苦流涕，说你消灭了一个商业奇才",
//         chooseArr:[
//             {name:"我知道了",skipEvent: true},
//         ],
//     },//第一天；老六事件结束
//     "28":{// 第二天投资后 ！老六//气泡！兄弟我对不住你啊
//         id:"28",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"兄弟我对不住你啊",
//         dec:"新能源汽车已经饱和了！卖不出去，没关系我另外一个朋友凤雏！出了一个想法，将新年能源摩托车，改成共享的！但是前期推广运营费用需要80w，你是否选择追投 ",
//         chooseArr:[
//             {name:"追投!",nextEventId:37,meAsk:" 没想到小小村子居然出现你们两个人才！这钱我投了",skipEvent: true ,chooseParam : { key : "coin" , value : -800000}},
//             {name:"不追投!",meAsk:"兄弟，我感觉这个不行啊",nextEventId:29},
//         ],
//     },
//     "29":{
//         id:"29",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"",
//         dec:"你就这么不相信我嘛、罢了罢了！老六对你很失望 ",
//         chooseArr:[
//             {name:"我知道了",skipEvent: true},
//         ],
//         //老六事件结束
//     },
//     "30":{//老舅 开始！第一天
//         id:"30",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"陆游器",
//         belongNpc:"老舅",
//         simpleDesc:"这小子！不是小时候的爱哭鬼吗",
//         startTaskFlag : true,
//         startDay:0,
//         dec:"你看小时候的爱哭鬼，一眨眼就张大了啊！真是你看老舅都老了",
//         chooseArr:[
//             {name:"安慰老舅!",nextEventId:32,meAsk:"老舅不老了！听说老舅最近跳广场舞！跳的还很嗨"},
//             {name:"不好意思",nextEventId:31,meAsk:"老舅别说了！那都是小时候的事情了！"},
//         ],
//     },
//     "31": {
//         id: "31",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "陆游器",
//         belongNpc: "老舅",
//         dec: " 咋啦小时候的事情不是事情了，老舅不跟你说，今天找你想要你给老舅圆梦",
//         simpleDesc:"",
//         chooseArr: [
//             {name: "直接询问!", nextEventId: 33, meAsk: "老舅有话你直接说！"},
//             {name: "开开玩笑", nextEventId: 33, meAsk: "老舅的梦想，不是天天跟老太太跳广场舞吗？"},
//         ],
//     },
//     "32":{
//         id:"32",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"陆游器",
//         belongNpc:"老舅",
//         dec:" 快别说了，再说你舅妈，要来了!老舅今天来找你是想圆舅梦！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"直接询问!",nextEventId:33,meAsk:"老舅有话你直接说！"},
//             {name:"开开玩笑",nextEventId:33,meAsk:"老舅的梦想，不是天天跟老太太跳广场舞吗？"},
//         ],
//     },
//     "33":{
//         id:"33",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"陆游器",
//         belongNpc:"老舅",
//         simpleDesc:"",
//         dec:" 哈哈哈！！不是看你开了这个什么圆梦大会吗？老舅也发明了一个东西，叫做陆游器一直没机会推广。现在拿出来，给你看看能不能帮老舅圆梦一下。",
//         chooseArr:[
//             {name:"陆什么器!",nextEventId:34,},
//             {name:"什么器？",nextEventId:34,meAsk:"老舅的梦想，不是天天跟老太太跳广场舞吗？"},
//         ],

//     },
//     "34":{
//         id:"34",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"陆游器",
//         belongNpc:"老舅",
//         simpleDesc:"",
//         dec:" 陆游器！就是可以在陆地上游泳的东西，我的梦想是让所有人在陆地上能够游泳！让游泳脱离水的舒服，随时想游就游。",
//         chooseArr:[
//             {name:"送老舅出门!",meAsk:"老舅，舅妈来了你快跑",skipEvent: true },
//             {name:"支持老舅 ",nextEventId:35,meAsk:"老舅我觉得你这个想法很好！你肯定看过西红柿"},
//         ],
//     },

//     "35":{
//         id:"35",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"陆游器",
//         belongNpc:"老舅",
//         simpleDesc:"",
//         dec:" 什么柿？那玩意没看过，老舅舅问你支不支持老舅吧！",
//         chooseArr:[
//             {name:"不支持!",meAsk:"老舅，舅妈来了你快跑",skipEvent: true },

//             {name:"支持 ",nextEventId:38,meAsk:"好的！老舅我这就给你打钱-50w",skipEvent: true ,chooseParam : { key : "coin" , value : -500000 }
//                 ,logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "开启项目的第一天，陆游器正在制作中，花了50w",
//                         //影响盘子金额
//                         coinChange : -500000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                     {
//                         desc : "老舅叫你去体验一下陆游器",
//                         //影响盘子金额
//                         coinChange : 0,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                         //追投文案
//                         chasingThrowDesc : "你尝试了一下陆游器，喝的挺饱~，于是你边吐边走了出来了",
//                         //追投 下一个事件id
//                         eventId:0,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "陆游器一经过问世，好评如潮！现在你老舅家已经发了，这是分给你+300w",
//                         //影响盘子金额
//                         coinChange : 5000000,
//                         //影响用户金额
//                         userCoinChange : 3000000,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                 ],},

//         ],
//     }, //老舅事件第一天全部结束

//     "36":{
//         id:"36",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"陆游器",
//         belongNpc:"老舅",
//         dec:" 大外甥，你快看，我先用家里的便器做了一款，陆游器，你要不要试试看。",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"试试!",meAsk:"你尝试了一下陆游器,喝的挺饱~，于是你跑边吐出来了",skipEvent: true },
//             {name:"不试了 ",meAsk:"我：不用试了，大舅我还不相信你吗"},
//         ],
//     },
//     "37":{
//         id:"37",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"温州批发",
//         belongNpc:"表姑",
//         dec:"当当当，表姑直播买起了鞋！凭借着！不要问我为什么，厂长是我表哥！努力赚了200w 分了你100w",
//         simpleDesc:"我搞直播赚钱了",
//         chooseArr:[
//             {name:"我知道了",skipEvent: true },
//         ],
//     },
//     "38":{
//         id:"38",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"新能源摩托车",
//         belongNpc:"老六",
//         simpleDesc:"赚钱了",
//         dec:"由于你精准的商业眼光，本次投资已经已经赚了500w",
//         chooseArr:[
//             {name:"我知道了",skipEvent: true },
//         ],
//     },

//     "100":{
//         id:"100",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,//村口大爷
//         name:"广场改造工程",
//         belongNpc:"村口大爷",
//         simpleDesc:"回来看你大爷啦，还记得你大爷吗",//首次气泡
//         startTaskFlag : true,
//         startDay:1,//开始天数
//         dec:"小伙子真有孝心啊，这么早就知道回来过年了，你进村的时候看到村口的那块坪了吗，我有一个想法，就是把村口的那个空地改造成一个广场，这样每天吃完饭村里的那些没啥事干的老大妈们都愿意来跳广场舞，这样我就有机会不打光棍了",
//         chooseArr:[
//             {name:"大爷好想法啊!",nextEventId:101},
//             {name:"一把年纪还想脱单？",nextEventId:102},
//         ],//跳转到对话102
//     },
//     "101":{//对话2
//         id:"101",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"广场改造工程",
//         belongNpc:"村口大爷",
//         simpleDesc:"",
//         dec:"那肯定，我这个想法已经想了好多年了，这样不但解决了我们村里一直空地的问题，还帮我们村里的老人增加了娱乐活动，现在最重要的就是你大爷还差了些钱，不多，就只要51w，不过大爷我已经存了1w了，只要你借50w给我，我保证搞定这个事情",
//         chooseArr:[{name:"这肯定帮您！",nextEventId:103,skipEvent:true}]//投资结束-50W，跳到103执行第二天的追投并记录投资情况
//     },
//     "102": {
//         id: "102",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "广场改造工程",
//         belongNpc: "村口大爷",
//         simpleDesc:"",
//         dec: "怎么你看不起老人家啊，知道有个词叫老当益壮吗？我可是你大爷，你要尊敬老人家知不知道（不开心的走了）",
//         chooseArr:[{name:"知道了！",skipEvent:true}]
//     },
//     "103": {
//         id: "103",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "广场改造工程",
//         belongNpc: "村口大爷",
//         dec: "谢谢小伙啦",
//         simpleDesc:"谢谢小伙啦",
//         chooseArr: [
//             {
//                 name: "投资", nextEventId: 104, meAsk: "舞动乾坤，呼哈嘿",
//                 skipEvent: true,
//                 chooseParam: {key: "coin", value: -500000},
//                 logInfo: [
//                     {
//                         desc: "感谢你啦，大老板，广场已经搭建起来啦，村里大妈可爱在那玩了，我都处了好几个对象了。只是呀，他们说音响质量不够好，他买了一个顶级的音响花了50w",
//                         coinChange: 500000,
//                         userCoinChange : 0,
//                         chasingThrowCoin: 500000,//要加投多少钱
//                         chasingThrowDesc: "村口大爷，资金有点空缺希望你继续加投50w",
//                         eventId: 105,
//                     },
//                 ]
//             },
//         ],
//     },
//     //
//     "104":{
//         id:"104",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"广场改造成功",
//         belongNpc:"村口大爷",
//         dec : "广场改造以后效果很好，村里的大多数人都会来广场进行娱乐，其中的门票带来了不错的收益,分红给你100w",
//         simpleDesc:"广场改造后效果很好",
//         chooseArr:[{name:"我去！！",skipEvent:true,chooseParam:{key:"coin",value:1000000}}]
//     },
//     //第二天
//     "105":{
//         id:"105",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"广场改造工程",
//         belongNpc:"村口大爷",
//         dec : "大爷对广场进行了vip包厢的定制扩建，不错的口碑名气，也吸引来了不少高端用户，收益+5000000，分红一半给你",
//         simpleDesc:"现在的广场很嗨皮啊",
//         chooseArr:[{name:"嗨，又赚了！",skipEvent:true,chooseParam:{key:"coin",value: 25000000 }}]
//     },

//     /**
//      * 大聪明start
//      */
//     "110":{
//         id:"110",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,//村口大爷
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         simpleDesc:"哥，嘿嘿嘿",//首次气泡
//         startTaskFlag : true,
//         startDay:4,//开始天数
//         dec:"哥，你看看我，是我啊，小时候和你一起玩的大聪明啊。还认得我吗？",
//         chooseArr:[
//             {name:"认得",nextEventId:111,meAsk:"是大聪明啊，我当然记得，听说你最近修炼了好几年的武当梯云纵，把鞋都踩烂了好几双"},
//             {name:"不认得",meAsk:"你是。。。谁？",nextEventId:112},
//         ],
//     },
//     "111":{
//         //对话2
//         id:"111",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"是大聪明啊，我当然记得，听说你最近修炼了好几年的武当梯云纵，把鞋都踩烂了好几双,你找我有什么事吗？",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"商讨大事",meAsk:"什么大事，说来听一听 ",nextEventId:117},
//             {name:"提出疑问",meAsk:"什么大事?说来听一听",nextEventId:117},
//         ]
//     },

//     "112":{
//         id:"112",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"不认识我不重要，不过我找你是有大事商量",
//         simpleDesc:"",
//         chooseArr:[{name:"商讨大事",meAsk:"什么大事，说来听一听 ",nextEventId:113},
//             {name:"提出疑问",meAsk:"什么大事，说来听一听",nextEventId:113}]
//     },
//     "113":{
//         id:"113",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"咳咳，这就需要我们的共享手机柜登场了，扫一扫即可解决忘带手机的烦恼。市场潜力巨大，老板你要不要考虑一下，只要100W",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"赞同",meAsk:"你一定是智多星下凡，聪明盖世呀！！",nextEventId:114},
//             {name:"赶出去",nextEventId:115},
//         ]
//     },

//     "114":{
//         id:"114",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"哪里哪里。大哥过奖了。我保证，只要给我20W，我就能创造奇迹",
//         simpleDesc:"",
//         chooseArr:[
//             {
//                 name:"投",meAsk:"我见你打小就聪明，一定能成为我的左膀右臂，这里是20W，希望你给我带来好消息",
//                 chooseParam : {key:"coin",value:-200000},
//                 skipEvent: true,nextEventId:118,
//                 logInfo : [
//                     {
//                         desc : "花了20w去弄了很多共享扫码的手机柜",
//                         coinChange : -200000,
//                         userCoinChange : 0,
//                         chasingThrowCoin : 500000,//要加投多少钱
//                         chasingThrowDesc : "加投50w",
//                         eventId:115
//                     },
//                     {
//                         desc : "花了50w去弄了更多共享扫码的手机柜",
//                         coinChange : -500000,
//                         userCoinChange : 0,
//                     },
//                 ]
//             },
//             {name:"不投",meAsk:"这样吧 你先回精神病院好好修养几天，痊愈后我再给你答复！",nextEventId:116}]
//     },
//     "116": {
//         id: "116",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "共享手机柜",
//         belongNpc: "大聪明",
//         dec: "好的老板，我等你消息",
//         simpleDesc:"我再等你的消息",
//         chooseArr: [{name: "去吧", skipEvent: true,}],
//     },
//     "117":{
//         id:"117",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"咳咳，你听我说，老板，这个项目是这样子的，现如今人人都有手机，但是忘带了手机怎么办呢?",
//         simpleDesc:"",
//         chooseArr:[
//             { name:"疑问",nextEventId:113,meAsk:"那怎么办" },
//             { name:"怼他",meAsk:"世界那么大，能认识你，我觉得好不幸。你给我出去。。。",skipEvent: true },]
//     },
//     "118":{
//         id:"118",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"老板，出了点小意外，我发现大家根本不会不带手机出门，但是我有个优化方案。需要加钱，就50W，您看行吗？",
//         simpleDesc:"出了点小意外",
//         chooseArr:[
//             { name:"太聪明了",nextEventId:115,meAsk:"我看好这想法！详细说说！" },
//             { name:"不投",nextEventId:116,meAsk:"远处飘来了风笛声！！！",skipEvent: true },
//         ],
//     },
//     "115":{
//         id:"115",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"共享手机柜",
//         belongNpc:"大聪明",
//         dec:"就是花更多钱安装更多的扫码共享手机柜，普及开了肯定就有人使用了，就50W您看行吗？",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"我草，脑壳有包",skipEvent: true,meAsk:"远处飘来了风笛声！！！"},
//             {name:"让他离开",skipEvent: true,meAsk:"远处飘来了风笛声！！！"},
//         ],
//     },
//     /**
//      * 大聪明  end
//      *
//      */

//     /**
//      * 小外甥 start
//      */
//     "119":{
//         id:"119",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"相亲APP",
//         belongNpc:"小外甥",
//         simpleDesc:"奥特曼打怪兽，哼哼哈嘿。",
//         startTaskFlag : true,
//         startDay:4,
//         dec:"小舅，你终于回来过年啦，之前你答应过回来后买给我的奥特曼卡片你还记得吗，不会没有带吧？",
//         chooseArr:[
//             {name:"哎，我忘记了",nextEventId:120},
//             {name:"带了带了",nextEventId:125},
//         ],
//     },
//     "120":{
//         id:"120",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"相亲APP",
//         belongNpc:"",
//         dec:"我都提醒了你好多次，你还是不记得给我带，现在反正你要赔我，刚好我暑假报了个java培训班，现在在家里无聊想开发一个帮助老爷爷老奶奶们相亲的app，从我在村里观察了几天的情况来看，我们这个项目的成功率可以说是百分之百！！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"百分之百？",nextEventId:121,meAsk:"你确定？"},
//             {name:"小屁孩吹牛呢",nextEventId:124,meAsk:"瞎吹牛",skipEvent: true},
//         ],
//     },
//     "121":{
//         id:"121",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"相亲APP",
//         belongNpc:"小外甥",
//         dec:"真的是百分之百！我根据这几天观察的情况专门写了一个表，全村老龄化占比了80%以上，这种基数下只要我开发出来了针对老年人相亲的app一定是可以暴富的！这样我就可以靠自己的努力买上心心念念的奥特曼卡片了！小舅你帮我好不好~",
//         simpleDesc:"",
//         chooseArr:[
//             { name:"好好好，我帮你",nextEventId:122,meAsk:"我帮你好吧" },
//             { name:"请你去玩泥巴",nextEventId:124,meAsk:"一边玩去",skipEvent: true },
//         ],
//     },
//     "122": {
//         id: "122",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "相亲APP",
//         belongNpc: "小外甥",
//         dec: "小舅最爱你了！有你这样的有钱的小舅真好，这个项目我只需要100w，就可以在一天之内开发出来上线！",
//         simpleDesc:"",
//         chooseArr: [
//             {
//                 name: "投了！", nextEventId: 123, meAsk: "这项目小舅我投了", skipEvent: true,
//                 chooseParam: {key: "coin", value: -1000000},
//                 logInfo: [
//                     {
//                         desc : "昨天路过一个玩具店,购买奥特曼花了80w",
//                         coinChange : -800000,
//                         userCoinChange : 0 ,
//                         chasingThrowCoin : 1000000,
//                         chasingThrowDesc : "这次只要你再相信我一次，再给我100w，我肯定可以研发上线成功",
//                         eventId : 11123
//                     },
//                     {
//                         desc : "APP已经研发成功上线",
//                         coinChange : 6000000,
//                         userCoinChange : 0 ,
//                         chasingThrowCoin : 0,
//                     },
//                 ]
//             },
//             { name: "小舅在考虑一下", nextEventId: 124, meAsk: "我再想想好叭", skipEvent: true },
//         ],
//     },
//     "123":{
//         id:"123",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"相亲APP",
//         belongNpc:"小外甥",
//         dec:"小舅我对不起你，昨天路过一个玩具店后看到里面的奥特曼模型，一不小心就花了80w，不过小舅！这次只要你再相信我一次，再给我100w，我肯定可以研发上线成功！",
//         simpleDesc:"小舅对不起",
//         chooseArr:[
//             {name:"好吧",nextEventId:122,meAsk:"谁叫你是我小外甥呢！"},
//             {name:"你咋会整这事呢",nextEventId:124,meAsk:"我很失望"},
//         ],
//     },
//     "124":{
//         id:"124",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"相亲APP",
//         belongNpc:"小外甥",
//         dec:"我再也不想和你一起打卡片了，呜呜呜呜",
//         simpleDesc:"我不想跟你玩了",
//         chooseArr:[
//             {
//                 name:"给!",nextEventId:11123,meAsk:"谁叫你是我小外甥呢！",
//                 skipEvent: true ,
//                 chooseParam : { key : "coin" , value : -1000000 },
//                 logInfo : [
//                     {
//                         desc : "昨天路过一个玩具店,购买奥特曼花了80w",
//                         coinChange : -800000,
//                         userCoinChange : 0 ,
//                         chasingThrowCoin : 1000000,
//                         chasingThrowDesc : "这次只要你再相信我一次，再给我100w，我肯定可以研发上线成功",
//                         eventId : 11123
//                     },
//                     {
//                         desc : "APP已经研发成功上线",
//                         coinChange : 6000000,
//                         userCoinChange : 0 ,
//                         chasingThrowCoin : 0,
//                     },

//                 ],
//             },
//             { name:"不给",meAsk:"去玩泥巴吧！",skipEvent:true }
//         ],
//     },
//     "11123":{
//         id:"11123",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"相亲APP",
//         belongNpc:"小外甥",
//         dec:"小舅，APP已经研发成功上线啦，已经成功为好多村内孤寡老人牵线成功。这是你的分红300w",
//         simpleDesc:"APP成功上线啦",
//         chooseArr:[
//             { name:"有点666！",meAsk:"我帮你好吧",skipEvent: true ,chooseParam:{key :"coin",value:3000000}},
//         ],
//     },
//     /**
//      */
//     /**
//      * 皮鞋王子
//      */
//     "125":{
//         id:"125",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"王子皮鞋厂",
//         belongNpc:"皮鞋王子",
//         simpleDesc:"我的小表弟啊，想不到你出息啦，又听说你在搞什么圆梦大会。我鞋都不卖了就跑来看你。",
//         startTaskFlag : true,
//         startDay:1,
//         dec:"小老弟呀，我也有个小梦想。你想听吗？",
//         chooseArr:[
//             {name:"询问",nextEventId:126,meAsk:"你有什么梦想？"},
//             {name:"听一听",nextEventId:127,meAsk:"说来听听"},
//         ],
//     },
//     "126":{
//         id:"126",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:" 王子皮鞋厂",
//         belongNpc:"皮鞋王子",
//         dec:"那我就直说啦，我在村里当了十年的鞋匠，梦想就是开一家属于自己的皮鞋厂",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"赞同",nextEventId:127,meAsk:"我欣赏你，我支持你的梦想！"},
//             {name:"委婉拒绝",nextEventId:128,meAsk:"我欣赏你，我支持你的梦想！但是我不能投给你"},
//         ],
//     },
//     "127":{
//         id:"127",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:" 王子皮鞋厂",
//         belongNpc:"皮鞋王子",
//         dec:"皮鞋万岁！！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"投",nextEventId:129,meAsk:"有梦想谁都了不起！详细说说！",},
//             {name:"不投",nextEventId:128,meAsk:"哎呀，表哥，现在没多少人穿土气的皮鞋啦，要不你做运动鞋吧"},
//         ],
//     },

//     "128": {
//         id: "128",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: " 王子皮鞋厂",
//         belongNpc: "皮鞋王子",
//         dec: "我不管！皮鞋万岁！！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"不聊了！",meAsk:"。。。。。。",skipEvent: true},
//         ],
//     },

//     "129":{
//         id:"129",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:" 王子皮鞋厂",
//         belongNpc:"皮鞋王子",
//         dec:"请看我们的最新量产型黄金切尔希，不要急，不要抢，这位帅锅，王八牌皮鞋，这种鞋子穿到叙利亚，飞机来了都不怕，原价一百多，现价三百多！买不了上当，买不了吃亏！不要问我为甚莫，厂长是你表锅！！！锅！锅！锅！锅！",
//         simpleDesc:"",
//         chooseArr:[
//             {
//                 name:"投他50W",nextEventId:130,meAsk:"",
//                 skipEvent: true ,
//                 chooseParam : { key : "coin" , value : -500000 },
//                 logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "花50w购置了新的机器，效率大大提升,顾客非常很喜欢",
//                         //影响盘子金额
//                         coinChange : -500000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         chasingThrowCoin : 0,
//                     },
//                 ],
//             },

//         ],
//     },
//     "130": {
//         id: "130",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: " 王子皮鞋厂",
//         belongNpc: "皮鞋王子",
//         dec: "皮鞋大卖，销售额直接突破3000w，盈利1000w，分红给你500w",
//         simpleDesc:"皮鞋大卖了",
//         chooseArr:[
//             { name:"牛的！！",meAsk:"没看出来啊！",skipEvent: true , chooseParam :{ key :"coin" , value : 5000000} },
//         ],
//     },
//     /**
//      * 皮鞋王子 end
//      */

//     /**
//      * 周某人
//      */
//     "131":{
//         id:"131",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"电瓶车公司",
//         belongNpc:"周某人",
//         simpleDesc:"看来村里人个个都是人才耶。看来我今天得让你走路回去了",
//         startTaskFlag : true,
//         startDay:4,
//         dec:"你找我有什么事嘛",
//         chooseArr:[
//             {name:"反问",nextEventId:132,meAsk:"难道不是你找我吗？？？"},
//             {name:"闲聊",nextEventId:132,meAsk:"我听说你有个电瓶车公司，来找我是遇到什么困难了吗？"},
//         ],
//     },
//     "132":{
//         id:"132",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"电瓶车公司",
//         belongNpc:"",
//         dec:"这你就大错特错了，是你需要我。我有个全新的新能源项目，有没有兴趣了解下？",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"有兴趣",nextEventId:133,meAsk:"说出你的想法"},
//             {name:"没兴趣",nextEventId:134,meAsk:"完全没有兴趣呢"},
//         ],
//     },
//     "133":{
//         id:"133",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"电瓶车公司",
//         belongNpc:"周某人",
//         dec:"现在新能源产业非常发达，但是还没有人做过新能源摩托车，我觉得我们可以做新能源摩托车。实现商业垄断 ",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"赞同",nextEventId:137,meAsk:"想不到你还有这样的商业头脑  你需要多少资金？"},
//             {name:"质疑",nextEventId:135,meAsk:"新能源摩托车？这不就是电动车吗？",skipEvent: true},
//         ],
//     },
//     "134": {
//         id: "134",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "电瓶车公司",
//         belongNpc: "周某人",
//         dec: "仰天长啸出门去，我辈岂是打工人？!!哈哈哈哈哈",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"额！",skipEvent: true},
//         ],
//     },
//     "135":{
//         id:"135",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"电瓶车公司",
//         belongNpc:"周某人",
//         dec:"当然不是这样的，名字不同，自然做起来心情也不同。",
//         simpleDesc:"不是这样的",
//         chooseArr:[
//             {name:"投了",nextEventId:136,meAsk:"听起来有点道理，这项目我投了！",},
//             {name:"不投",nextEventId:136,meAsk:"......"},
//         ],
//     },
//     "136": {
//         id: "136",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "电瓶车公司",
//         belongNpc: "周某人",
//         simpleDesc:"我辈岂是蓬莱人",
//         dec: "好，50W项目启动资金",
//         chooseArr: [
//             {
//                 name: "给!", nextEventId: 137, meAsk: "给，拿去！",
//                 skipEvent: true,
//                 chooseParam: {key: "coin", value: -500000},
//                 logInfo: [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc: "置办了地方和组织了人手，花了50w",
//                         //影响盘子金额
//                         coinChange: -500000,
//                         //影响用户金额
//                         userCoinChange: 0,
//                         //追投金钱
//                         chasingThrowCoin: 0,
//                     },
//                     {
//                         desc: "邹某人因为组织员工偷电瓶创业被警方抓走了，你作为出资人被警方罚了200W。！",
//                         //影响盘子金额
//                         coinChange: 0,
//                         //影响用户金额
//                         userCoinChange: -2000000,
//                         //追投金钱
//                         chasingThrowCoin: 0,
//                     },

//                 ],
//             },
//         ],
//     },
//     //第二天
//     "137":{
//         id:"137",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"电瓶车公司",
//         belongNpc:"周某人",
//         dec:"我想创立一个电瓶车公司，需要100w",
//         simpleDesc:"我想创立电瓶车公司",
//         chooseArr:[
//             {name:"投了",meAsk:"听起来有点道理，这项目我投了！",nextEventId:138,chooseParam : { key : "coin" , value : -1000000 },},
//             {name:"不投",meAsk:"新能源摩托车？这不就是电动车吗？",skipEvent: true},
//         ],
//     },
//     "138":{
//         id:"138",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"电瓶车公司",
//         belongNpc:"周某人",
//         dec:"因为该偷电瓶事件被影响，公司解散了",
//         simpleDesc:"咳，公司黄了",
//         chooseArr:[
//             {name:"知道了",skipEvent: true},
//         ],
//     },
//     /**
//      * 李 阿姨 第一天
//      */
//     "301":{
//         id:"301",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"按摩店",
//         belongNpc:"李阿姨",
//         simpleDesc:"我是你姨啊小崽子",
//         startTaskFlag : true,
//         startDay:1,
//         dec:"哎呀真的是你啊，好多年都没见过啦，还记得小时候你和我女儿一起去上学吗，那时候你每天跑我家来玩~,李阿姨小时候还抱过你呢！没想到一晃你这么大了！",
//         chooseArr:[
//             {name:"记得!",nextEventId:302,meAsk:"李阿姨啊，我记得"},
//             {name:"不记得!",nextEventId:304,meAsk:"居然有这个事情,我都不记得了"},
//         ],
//     },
//     "302":{
//         id:"302",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"李阿姨",
//         belongNpc:"李阿姨",
//         dec:"那肯定，你小时候天天跑来玩，就是时间过的好快啊，一眨眼你都这么大了，我年纪也大了，现在村子里的老人身体越来越差了，村里也一直缺个按摩店给大家放松一下身体，我想在村里开一家世界上最帅的帅哥按摩店需要80W，这样一来解决了村里的身体问题，还能吸引更多年轻漂亮的女孩子来村里，这样不是一举两得！",
//         simpleDesc:"",
//         chooseArr:[
//             {
//                 name:"支持李阿姨!" , nextEventId:303 , meAsk:"李阿姨你真是个天才！这点钱你就直接先拿去吧" , skipEvent: true ,
//                 chooseParam : { key : "coin" , value : -800000 },
//                 logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc: "开启项目的第一天，按摩店正在建设中，花了30w",
//                         //影响盘子金额
//                         coinChange: -300000,
//                         //影响用户金额
//                         userCoinChange: 0,
//                         //追投金钱
//                         chasingThrowCoin: 0,
//                     },
//                     {
//                         desc: "李阿姨觉得店内简陋影响生意，又花30w进行了装修",
//                         //影响盘子金额
//                         coinChange: -300000,
//                         //影响用户金额
//                         userCoinChange: 0,
//                         //追投金钱
//                         chasingThrowCoin: 500000,
//                         //追投文案
//                         chasingThrowDesc: "小帅哥，有空来我的按摩店玩玩呀，您要是愿意多投点个50W的话，我还可以开个连锁店，哈哈哈 ",
//                         //追投 下一个事件id
//                         eventId: 303,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc: "店内生意爆火！生意收益300W,分你100W",
//                         //影响盘子金额
//                         coinChange: 2000000,
//                         //影响用户金额
//                         userCoinChange: 1000000,
//                         //追投金钱
//                         chasingThrowCoin: 0,
//                     },
//                 ],
//             },
//             {name:"不支持!",meAsk:"这不太好吧，按摩店影响有点大。",skipEvent: true },
//         ],
//     },
//     "303":{
//         id:"303",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"按摩店",
//         belongNpc:"李阿姨",
//         dec:"小帅哥，有空来我的按摩店玩玩呀，您要是愿意多投点个50W的话，我还可以开个连锁店，哈哈哈 ",
//         simpleDesc:"我想开连锁店",
//         chooseArr:[
//             { name:"追投!" , meAsk:"做大做强我们 " , nextEventId:305 , skipEvent: true , chooseParam : { key : "coin" , value : -500000 } },
//             { name:"不追投!" , meAsk:"不了我只造福乡里。。。。" , skipEvent: true},
//         ],
//     },
//     "304": {
//         id: "304",
//         type: SPEND_MODE_EVENT_TYPE.DREAM,
//         name: "按摩店",
//         belongNpc: "李阿姨",
//         dec: " 没事，不记得也没关系，还认识我是你姨就可以，不过一眨眼你都这么大了，我年纪也大了，现在村子里的老人身体越来越差了，村里也一直缺个按摩店给大家放松一下身体，我想在村里开一家世界上最帅的帅哥按摩店需要80w，还能吸引更多年轻漂亮的女孩子来村里，这样不是一举两得！",
//         simpleDesc:"",
//         chooseArr: [
//             {
//                 name: "支持!",
//                 nextEventId: 303,
//                 meAsk: "李阿姨你真是个天才！这点钱你就直接先拿去吧",
//                 skipEvent: true,
//                 chooseParam: {key: "coin", value: -800000},
//                 logInfo: [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc: "开启项目的第一天，按摩店正在建设中，花了30w",
//                         //影响盘子金额
//                         coinChange: -300000,
//                         //影响用户金额
//                         userCoinChange: 0,
//                         //追投金钱
//                         chasingThrowCoin: 0,
//                     },
//                     {
//                         desc: "李阿姨觉得店内简陋影响生意，又花30w进行了装修",
//                         //影响盘子金额
//                         coinChange: -300000,
//                         //影响用户金额
//                         userCoinChange: 0,
//                         //追投金钱
//                         chasingThrowCoin: 500000,
//                         //追投文案
//                         chasingThrowDesc: "小帅哥，有空来我的按摩店玩玩呀，您要是愿意多投点个50W的话，我还可以开个连锁店，哈哈哈 ",
//                         //追投 下一个事件id
//                         eventId: 303,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc: "店内生意爆火！生意收益300W,分你100W",
//                         //影响盘子金额
//                         coinChange: 2000000,
//                         //影响用户金额
//                         userCoinChange: 1000000,
//                         //追投金钱
//                         chasingThrowCoin: 0,
//                     },
//                 ],
//             },
//             {name: "不支持!", meAsk: "那不行我不爱按摩店"},
//         ],
//     },
//     "305":{
//         id:"305",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"按摩店",
//         belongNpc:"李阿姨",
//         dec:"小帅哥，感谢你的投资，我的按摩店已经开到了国外，这是你的分红",
//         simpleDesc:"按摩店开到了国外，效益很不错哦",
//         chooseArr:[{name:"我知道了",skipEvent: true ,chooseParam:{key:"coin",value:10000000}}],
//     },
//     //李阿姨结束
//     "306":{// 外婆！开始！第一天
//         id:"306",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"菜市场",
//         belongNpc:"外婆",
//         simpleDesc:"我的乖孙孙呐,快过来，让外婆看看。",
//         startTaskFlag : true,
//         startDay:1,
//         dec:"外婆：哎哟这不我大外孙吗，这出息的，外婆看到你来可开心死啦~今天一定要在我家吃饭，让你试试我最新研究的火星温室大棚菜，你看你现在胖的，还可以减肥嘞，你快尝尝~,！",
//         chooseArr:[
//             {name:"试试!",nextEventId:307,meAsk:"真好吃！"},
//             {name:"不尝？!",nextEventId:310,meAsk:"外婆！我不吃这些的"},
//         ],
//     },
//     "307":{
//         id:"307",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"菜市场",
//         belongNpc:"外婆",
//         dec:"好吃吧~现在就愁没有钱了，只要有钱一定可以把村里唯一的菜市场抢占下来，只要占领下来我在村里谁看见我不叫一声老大，你快考虑一下，",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"冲!",nextEventId:308,meAsk:"那肯定冲啊！外婆加油"},
//             {name:"不尝？!",nextEventId:310,meAsk:"外婆！我不吃这些的"},
//         ],
//     },
//     "308":{
//         id:"308",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"菜市场",
//         belongNpc:"外婆",
//         dec:"外婆，过然没有白疼你啊！前期投入成本只需要60w就可以启动了！你快准备拿给我",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"好的!",nextEventId:309,meAsk:"好的外婆，这是给你的60W",skipEvent: true ,
//                 chooseParam : { key : "coin" , value : -600000 }
//                 ,logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "开启项目的第一天，外婆家食神店，花了30w",
//                         //影响盘子金额
//                         coinChange : -300000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                     {
//                         desc : "外婆想创立品牌需要130w缺少100w，又来向你要走100w",
//                         //影响盘子金额
//                         coinChange : -1300000,
//                         //影响用户金额
//                         userCoinChange : -1000000,
//                         //追投金钱
//                         chasingThrowCoin : 1000000,
//                         //追投文案
//                         chasingThrowDesc : "我创立了个品牌，名字叫老妈妈，你觉得怎么样啊。但是还需要100W品牌代言费 ",
//                         //追投 下一个事件id
//                         eventId:309,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "公司上市，资金回笼3000w,分红你1500w",
//                         //影响盘子金额
//                         coinChange : 15000000,
//                         //影响用户金额
//                         userCoinChange : 15000000,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                 ],
//             },
//             {name:"不支持？!",nextEventId:310,meAsk:"外婆！你好好休息吗，别做这些！让年轻人忙吧！"},
//         ],
//     },
//     "309":{
//         id:"309",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"菜市场",
//         belongNpc:"外婆",
//         dec:"好吃吧~我创立了个品牌，名字叫老妈妈，你觉得怎么样啊。但是还需要100W品牌费。",
//         simpleDesc:"我创立个品牌，还差点品牌费",
//         chooseArr:[
//             {name:"支持外婆!",meAsk:"那肯定冲啊！外婆加油",skipEvent: true ,},
//             {name:"觉得不妥!",meAsk:"外婆！你的想法满潮的，但是我们从长计议吧！",nextEventId:310,skipEvent: true ,},
//         ],
//     },
//     "310":{
//         id:"310",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"菜市场",
//         belongNpc:"外婆",
//         dec:"看来是外婆老了。外婆很伤心的走开了",
//         simpleDesc:"我伤心了",
//         chooseArr:[
//             {name:"我知道了 ",skipEvent: true ,},
//         ],
//     },//外婆事件全部结束
//     "311":{// 大舅！开始！第一天
//         id:"311",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"旅游区",
//         belongNpc:"大舅",
//         simpleDesc:"侄子，方便谈一会吗？",
//         startTaskFlag : true,
//         startDay:1,
//         dec:"~,侄子！我有一个很好的项目，我们能合作吗？",
//         chooseArr:[
//             {name:"疑问!",nextEventId:312,meAsk:"大舅，什么项目》"},
//             {name:"听听看!",nextEventId:312,meAsk:"你讲吧！大舅我们谁跟谁啊"},
//         ],
//     },
//     "312":{
//         id:"312",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"旅游区",
//         belongNpc:"大舅",
//         dec:"~,是这样的，村子周边的自然风光很美，可以改造成风光旅游区，一定会让全村人致富，过上好日子。",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"支持!",nextEventId:313,meAsk:"你说的对！大舅还是你懂我！我要让全村人富起来！"},
//             {name:"不支持!",meAsk:"我觉得游客太多了会破坏村子的生态，我想让村子纯粹"},
//         ],
//     },
//     "313":{
//         id:"313",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"旅游区",
//         belongNpc:"大舅",
//         dec:"只需要200W，我这边就能将村子改造成旅游村哦",
//         simpleDesc:"",
//         chooseArr:[
//             {
//                 name:"支持!",nextEventId:314,meAsk:"先富带后富！共创美好未来",skipEvent: true ,
//                 chooseParam : { key : "coin" , value : 2000000 },
//                 logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "第一天，正在跟村民商业旅游区中，花了150w",
//                         //影响盘子金额
//                         coinChange : -1500000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                     {
//                         desc : "为了给旅行打广告，广告资金花费50w",
//                         //影响盘子金额
//                         coinChange : -500000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 500000,
//                         //追投文案
//                         chasingThrowDesc : "目前旅游项目效果不怎么理解，希望继续筹备广告资金50W进行推广，希望再支持一下哦",
//                         //追投 下一个事件id
//                         eventId:314,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "旅游经济飞速发展盈利900w，你获得了分红+300W",
//                         //影响盘子金额
//                         coinChange : 6000000,
//                         //影响用户金额
//                         userCoinChange : 3000000,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                 ],},
//             {name:"不支持!",meAsk:"要不算了吧，我不想影响村子的生态",skipEvent: true ,},
//         ],
//     },
//     "314":{
//         id:"314",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"旅游区",
//         belongNpc:"大舅",
//         dec:"目前旅游项目效果不怎么理解，希望继续筹备广告资金50W进行推广，希望再支持一下哦",
//         simpleDesc:"希望你再支持",
//         chooseArr:[
//             {name:"支持!",nextEventId:315,meAsk:"大舅别怕，缺多少跟我说！",skipEvent: true ,chooseParam : { key : "coin" , value : -500000 } },
//             {name:"不支持!",meAsk:"要不算了吧，这也不知道什么时候时候个头啊！",skipEvent: true },
//         ],
//     },
//     "315":{
//         id:"315",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"旅游区",
//         belongNpc:"大舅",
//         simpleDesc:"告诉你一个好消息",
//         dec:"目前项目情况良好，这是您的分红+1千万" , //skipEvent: true ,chooseParam : { key : "coin" , value : 800000 }
//         chooseArr:[
//             {name:"我知道了",skipEvent: true ,chooseParam : { key : "coin" , value : 10000000 }},
//         ],
//     },//大舅事件完结
//     "316":{// 萧片子！开始！第一天
//         id:"316",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项",
//         belongNpc:"萧片子",
//         simpleDesc:"铁子，我这有个大项目要招合伙人，有没有兴趣",
//         startTaskFlag : true,
//         startDay:4,
//         dec:"哥，有钱大家一起赚啊。我有个秘密项目，你要不要听听~背叛我的我都给几个亿，支持我的你去想想！",
//         chooseArr:[
//             {name:"听听!",nextEventId:317,meAsk:"我有兴趣,说来听听"},
//             {name:"不记得!",nextEventId:304,meAsk:"居然有这个事情,我都不记得了"},
//         ],
//     },
//     "317":{
//         id:"317",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项",
//         belongNpc:"萧片子",
//         dec:"体情况在这不方便说，我只能说十联郭合的绝密项目，只要做好了最起码挣十个亿。",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"震惊!",nextEventId:318,meAsk:"真的假的",},
//             {name:"不屑一顾!",meAsk:"我看你是个骗子，走开",skipEvent: true},
//         ],
//     },
//     "318":{
//         id:"318",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项",
//         belongNpc:"萧片子",
//         dec:"真的！这个项目级别比较高，现在很多人都在抢这个项目，一般有钱也拿不到，必须有关系。关系呢，我也有，但是需要花点钱 我钱不太够",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"询问!",nextEventId:319,meAsk:"疏通关系要多少钱,不会骗我吧？"},
//             {name:"不屑一顾!",meAsk:"我看你是个骗子，走开",skipEvent: true},
//         ],
//     },

//     "319":{
//         id:"319",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项",
//         belongNpc:"萧片子",
//         dec:" 骗你干嘛！对于你这个大老板来说，真的不多！只要简简单单200w就行",
//         simpleDesc:"",
//         chooseArr:[
//             {   name:"好的!",nextEventId:320,meAsk:"拿去打通关系吧！", chooseParam : { key : "coin" , value : -2000000 } },
//             {   name:"不屑一顾!",meAsk:"我看你是个骗子，走开",skipEvent: true },
//         ],
//     },
//     "320":{
//         id:"320",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项",
//         belongNpc:"萧片子",
//         dec:" 哥！你还在吗？出了点问题，就差最后一步了，还差点钱啊！",
//         simpleDesc:"",
//         chooseArr:[
//             {name:"询问!",nextEventId:321,meAsk:"还差多少啊",},
//             {name:"差什么!",meAsk:"我看你是个骗子，走开",skipEvent: true ,},
//         ],
//     },
//     "321":{
//         id:"321",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项",
//         belongNpc:"萧片子",
//         dec:" 哥！还差一百万！那个项目抢的人太多了",
//         simpleDesc:"",
//         chooseArr:[
//             {
//                 name:"给他!",nextEventId:322,meAsk:"拿好，哥不差钱，搞定这个事情",skipEvent: true,
//                 chooseParam : { key : "coin" , value : -1000000 },
//                 logInfo : [
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "萧片子 正在谈十个亿项目中,花了200w打通关系",
//                         //影响盘子金额
//                         coinChange : -2000000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                     {
//                         desc : "又花了100w去疏通关系",
//                         //影响盘子金额
//                         coinChange : -1000000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 1000000,
//                         //追投文案
//                         chasingThrowDesc : "就是秘书长要塞点，副秘书长也要塞点，各个部门可能也要塞点，还缺点资金",
//                         //追投 下一个事件id
//                         eventId:322,
//                     },
//                     {
//                         //当天晚上发生的剧情内容
//                         desc : "萧片子跑路了",
//                         //影响盘子金额
//                         coinChange : -4000000,
//                         //影响用户金额
//                         userCoinChange : 0,
//                         //追投金钱
//                         chasingThrowCoin : 0,
//                     },
//                 ]},
//             {name:"差什么!",meAsk:"我看你是个骗子，走开",skipEvent: true ,},
//         ],
//     },
//     "322":{
//         id:"322",
//         type:SPEND_MODE_EVENT_TYPE.DREAM,
//         name:"十联项目",
//         belongNpc:"十个亿",
//         simpleDesc:"遇上我花光了你的运气",
//         dec:"萧片子，其实是个片子，现在你的钱已经没有了，我也没办法 ",
//         chooseArr:[{name:"我知道了",skipEvent: true }],
//     },
};

export default function getOneSpendEventById(id:number|string){
    return eventMap[id];
}

/**
 * 获取圆梦任务
 * @param day 天数
 */
export function getStartOnloadEvent( day : number ) : SpendModeEventI[]{
    let spendModeEventIArray : SpendModeEventI[] = [];
    for ( let id in eventMap ) {
        //第一天启动的任务
        if ( eventMap[id].startTaskFlag && eventMap[id].startDay == day ) {
            spendModeEventIArray.push( eventMap[id] );
        }
    }
    return spendModeEventIArray;
}

/**
 * 获取随机开始的事件
 * @param days
 */
export function getRandomStartEvent( npc : string , days : number ){
    let spendModeEventIArray : SpendModeEventI[] = [];
    for ( let id in eventMap ) {
        //第一天启动的任务
        if ( eventMap[id].startTaskFlag && eventMap[id].startDay <= days && eventMap[id].belongNpc == npc ) {
            spendModeEventIArray.push( eventMap[id] );
        }
    }
    return spendModeEventIArray[Math.floor( Math.random() * spendModeEventIArray.length )];
}

